var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"StatusAvatar",class:{
       'StatusAvatar__offline': !_vm.isOnline,
     },attrs:{"id":"StatusAvatar"}},[(!_vm.isOnline)?_c('v-icon',{staticClass:"StatusAvatar__offline--icon",attrs:{"size":"12px","color":"#8898AA"}},[_vm._v("mdi-sleep ")]):_vm._e(),_c('KeybeAvatar',{attrs:{"name":_vm.userName,"size":28,"img":_vm.user.photo || '',"isKeybeProfile":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }